import PageLoading from "@/components/ui/PageLoading";

export default function Loading() {
  return <PageLoading />
}
